module.exports = __webpack_public_path__ + "media/assets/services_manager/mail-2e5f6fdcee89b37246b808984ff71613012ec5166e026ca95440bc6369aa1e4b.svg";